import {
  FETCH_STARTER_KIT_PURCHASES_REQUEST,
  FETCH_STARTER_KIT_PURCHASES_SUCCESS,
  FETCH_STARTER_KIT_PURCHASES_FAILURE,

  FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST,
  FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS,
  FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE,

  UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST,
  UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS,
  UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE,
} from "../actions/types";


const initialState = {

  purchases: {
    data: [],
  },

  paymentProofs: {
    data: [],
  },

  loading: false,

  error: null,

  message: "",

  purchasesPage: 1,

  purchasesPages: 1,

  purchasesTotal: 0,

  paymentProofsPage: 1,

  paymentProofsPages: 1,

  paymentProofsTotal: 0,
};


const starterKitPurchaseReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {


    case FETCH_STARTER_KIT_PURCHASES_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case FETCH_STARTER_KIT_PURCHASES_SUCCESS: {

      const {
        data,
        page,
        pages,
        total,
      } = action.payload || {};

      return {
        ...state,

        loading: false,

        purchases: {
          data: data || [],
        },

        purchasesPage:
          page || 1,

        purchasesPages:
          pages || 1,

        purchasesTotal:
          total || 0,

        message:
          "Starter Kit Purchases loaded successfully",
      };
    }


    case FETCH_STARTER_KIT_PURCHASES_FAILURE:

      return {
        ...state,

        loading: false,

        error: action.payload,

        purchases: {
          data: [],
        },
      };



    case FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST:

      return {
        ...state,
        loading: true,
        error: null,
      };


    case FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS: {

      const {
        data,
        page,
        pages,
        total,
      } = action.payload || {};

      return {
        ...state,

        loading: false,

        paymentProofs: {
          data: data || [],
        },

        paymentProofsPage:
          page || 1,

        paymentProofsPages:
          pages || 1,

        paymentProofsTotal:
          total || 0,

        message:
          "Payment proofs loaded successfully",
      };
    }


    case FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE:

      return {
        ...state,

        loading: false,

        error: action.payload,

        paymentProofs: {
          data: [],
        },
      };


    case UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS: {

      const updatedProof =
        action.payload;

      return {
        ...state,

        loading: false,

        paymentProofs: {
          ...state.paymentProofs,

          data:
            Array.isArray(
              state.paymentProofs?.data
            )
              ? state.paymentProofs.data.map(
                  (proof) =>
                    proof.payment_id ===
                    updatedProof.payment_id
                      ? {
                          ...proof,
                          ...updatedProof,
                        }
                      : proof
                )
              : [],
        },

        message:
          "Payment proof updated successfully",
      };
    }


    case UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE:

      return {
        ...state,

        loading: false,

        error: action.payload,
      };


    default:
      return state;
  }
};


export default starterKitPurchaseReducer;